module.exports = {"230406001":"工人村街道","230406002":"新一街道","230406003":"三街街道","230406004":"东山街道","230406005":"鹤兴街道","230406100":"新华镇","230406201":"蔬园乡","230406202":"东方红乡","230406400":"鹤岗市林业局","230406501":"新华农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230406.json
// module id = 719
// module chunks = 0